module.exports = __webpack_public_path__ + "img/white.c4620a7d.png";